import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const NQICallForProposals2024 = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">NQI Call for Proposals 2024</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) National Quality Institute (NQI) invites proposals for research, projects, and initiatives aimed at improving verification, calibration, and quality services in Malawi.
          </p>
          <p className="subtitle">
            This call for proposals encourages innovative solutions, stakeholder engagement, and collaboration to strengthen measurement and quality systems nationally.
          </p>
        </div>
      </section>

      {/* === Purpose Section === */}
      <section className="intro-section">
        <h2 className="section-title">Purpose of the Call</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Support innovative projects in verification, calibration, and quality management</li>
              <li>Encourage research and development in measurement and metrology</li>
              <li>Promote stakeholder engagement and collaboration</li>
              <li>Enhance the effectiveness and reliability of NQI services</li>
              <li>Contribute to national and international standards compliance</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Identify practical solutions to challenges in industry and laboratories</li>
              <li>Foster knowledge sharing and capacity building</li>
              <li>Encourage adoption of best practices in measurement and calibration</li>
              <li>Provide opportunities for professional growth and recognition</li>
              <li>Support Malawi’s industrial development and quality assurance efforts</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Submission Guidelines Section === */}
      <section className="functions-section">
        <h2 className="section-title">Submission Guidelines</h2>
        <p>
          Interested stakeholders should submit detailed proposals including objectives, methodology, expected outcomes, and budget estimates. Proposals must align with NQI priorities and national quality objectives.
        </p>
        <ul>
          <li>Include a clear description of the project or research initiative</li>
          <li>Provide a detailed work plan and timeline</li>
          <li>Specify expected outcomes and impact on quality systems</li>
          <li>Attach necessary supporting documents and references</li>
          <li>Submit proposals via email or to the NQI office before the specified deadline</li>
        </ul>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for Proposals</h2>
        <p>
          For inquiries regarding the NQI Call for Proposals 2024 or submission process, please contact the National Quality Institute team at MBS.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:nqi@mbs.mw">nqi@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 111</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          The NQI Call for Proposals 2024 aims to foster innovation, collaboration, and quality improvement initiatives that strengthen Malawi’s verification and calibration services.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default NQICallForProposals2024;
